import React from "react";
import { Link } from "react-router-dom";
import SocialContainer from "./SocialNetworksContainer";
import "../scss/footer.scss";

const date = new Date().getFullYear();

const Footer = () => {
  return (
    <div className="footer-container">
      <SocialContainer />
      <p className="copyright">Cartésia © {date} | <Link className="mentions-link" to="/mentions">Mention légales</Link></p>
    </div>
  );
};

export default Footer;
